import { ClbDrawer } from '@celebration/react';
import { FooterDrawerType } from '@celebration/react/ClbDrawer/ClbDrawer.types';
import { useTranslation } from 'react-i18next';
import RangePicker from '../../range-picker';
import SelectAutocomplete from '../../select-autocomplete';
import { ILoadFilterAdvanced } from './ILoadFilterAdvanced';
import LocationFilter from './components/location-filter/location-filter';

export default function LoadFilterAdvanced(
    props: Readonly<ILoadFilterAdvanced>,
) {
    const {
        open,
        onClose,
        onApply,
        onClear,
        dateFilterProps,
        channelFilterProps,
        materialFilterProps,
        sourceLocationFilterProps,
        destinationLocationFilterProps,
    } = props;
    const { t } = useTranslation();

    const advancedFilterButtons: FooterDrawerType = [
        {
            key: 'advanced-filter-button',
            type: 'button',
            styleType: 'primary',
            size: 'md',
            iconPosition: 'none',
            disabled: false,
            loading: false,
            blockedWidth: false,
            label: t('Filtrar'),
            role: 'button',
            onClick: onApply,
            'data-testid': 'advanced-filter-button',
        },
        {
            key: 'advanced-filter-clean-button',
            type: 'button',
            styleType: 'tertiary',
            size: 'md',
            iconPosition: 'left',
            disabled: false,
            loading: false,
            blockedWidth: false,
            label: t('Limpar'),
            onClick: onClear,
            role: 'button',
            icon: 'subtract-rounded',
            'data-testid': 'advanced-filter-clean-button',
        },
    ];

    return (
        <div
            className="loads-filter__advanced-filter"
            data-testid="loads-filters__advanced-filter-container"
        >
            <ClbDrawer
                buttonsFooter={advancedFilterButtons}
                overlay
                title={t('Filtrar')}
                description={t('DescricaoFiltroAvancado')}
                size="lg"
                open={open}
                onClose={onClose}
                idUsedToOpenDrawer="open-drawer"
                id="load-advanced-filter-drawer"
            >
                <RangePicker
                    title=""
                    startDateLabel={t(dateFilterProps.startDateLabel)}
                    startDate={dateFilterProps?.startDate}
                    onChangeStartDate={dateFilterProps.onStartDateChange}
                    endDateLabel={t(dateFilterProps.endDateLabel)}
                    endDate={dateFilterProps.endDate}
                    onChangeEndDate={dateFilterProps.onEndDateChange}
                    key={dateFilterProps.id}
                    id={dateFilterProps.id}
                    minDate={dateFilterProps.minDate}
                    daysRangeLimit={dateFilterProps.daysRangeLimit}
                    data-testid={dateFilterProps.id}
                    canChooseSameDate
                />
                <SelectAutocomplete
                    id={channelFilterProps.id}
                    mode="multiple"
                    label={t(channelFilterProps.label)}
                    value={channelFilterProps.value}
                    onChange={channelFilterProps.onChange}
                    placeholder={t(channelFilterProps.placeholder)}
                    options={channelFilterProps.options}
                    maxTagCount="responsive"
                    data-testid={channelFilterProps.id}
                    key={channelFilterProps.id}
                    notFoundContent={t('NaoHaDadosParaExibir')}
                />
                <SelectAutocomplete
                    id={materialFilterProps.id}
                    mode="multiple"
                    label={t(materialFilterProps.label)}
                    value={materialFilterProps.value}
                    onChange={materialFilterProps.onChange}
                    placeholder={t(materialFilterProps.placeholder)}
                    options={materialFilterProps.options}
                    onSearch={materialFilterProps.onSearch}
                    onFetchDataResults={materialFilterProps.onFetchDataResults}
                    maxTagCount="responsive"
                    data-testid="load-product-advanced-filter"
                    notFoundContent={t('NaoHaDadosParaExibir')}
                />
                <LocationFilter {...sourceLocationFilterProps} />
                <LocationFilter {...destinationLocationFilterProps} />
            </ClbDrawer>
        </div>
    );
}
